module.exports = __webpack_public_path__ + "static/media/ic_hand_insurance_myway.7230fcd0.svg";